import { render, staticRenderFns } from "./feature.vue?vue&type=template&id=79ced856&scoped=true&"
import script from "./feature.vue?vue&type=script&lang=js&"
export * from "./feature.vue?vue&type=script&lang=js&"
import style0 from "./feature.vue?vue&type=style&index=0&id=79ced856&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ced856",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79ced856')) {
      api.createRecord('79ced856', component.options)
    } else {
      api.reload('79ced856', component.options)
    }
    module.hot.accept("./feature.vue?vue&type=template&id=79ced856&scoped=true&", function () {
      api.rerender('79ced856', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/lingyue-tech/index/component/feature/feature.vue"
export default component.exports